import React from 'react';
import { LayoutRoute } from 'components/Layout';
import { default as HomePublicaLayout } from 'components/Layout/HomePublica';
import ContainerEmpresas from './ContainerEmpresas';
import ContainerHomeMex from './ContainerHomeMex';

const HOME_ROUTES = [
  <LayoutRoute
    key="home"
    exact={true}
    path="/"
    component={ContainerHomeMex}
    layout={HomePublicaLayout}
  />,
  <LayoutRoute
    key="empresas"
    exact={true}
    path="/empresas"
    component={ContainerEmpresas}
    layout={HomePublicaLayout}
  />,
];

export default HOME_ROUTES;
